import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MapquoteService } from 'src/app/shared/services/mapquote.service';
// import { MapService } from '../../shared/services/map.service';
import { Subject } from "rxjs";

@Component({
  selector: 'app-quote-dialog-map',
  templateUrl: './quote-dialog-map.component.html',
  styleUrls: ['./quote-dialog-map.component.scss']
})
export class QuoteDialogMapComponent implements OnInit {
@Input() resetFormSubject: Subject<any> = new Subject<any>();
@Input() quoteMapCode;
  constructor(private map: MapquoteService) { }

  ngOnInit(): void {
     this.map.buildMap('quoteMap', this.quoteMapCode);
  }

  ngOnChanges(changes: SimpleChanges){
    this.resetFormSubject.subscribe(response => {
        
        this.map.setData(response)
    
   });
  }
}
